import { render, staticRenderFns } from "./DutyTeacher.vue?vue&type=template&id=2567f4e6&scoped=true"
import script from "./DutyTeacher.vue?vue&type=script&lang=js"
export * from "./DutyTeacher.vue?vue&type=script&lang=js"
import style0 from "./DutyTeacher.vue?vue&type=style&index=0&id=2567f4e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567f4e6",
  null
  
)

export default component.exports